import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { Constants } from 'src/app/models/constants';
@Component({
    selector: 'app-create-sandbox-dialog',
    templateUrl: './create-sandbox-dialog.component.html',
    styleUrls: ['./create-sandbox-dialog.component.scss'],
    standalone: false
})
export class CreateSandboxDialogComponent implements OnInit {
  title: string = translate('DIALOG.CONFIRMATION');
  Constants = Constants;
  serviceName: string;
  punchline: string;
  confirmButtonText: string = translate('DIALOG.CONFIRM');

  constructor(@Inject(MAT_DIALOG_DATA) private data: any) { }

  ngOnInit(): void {
    this.title = this.data.title || this.title;
    this.serviceName = this.data.serviceName;
    this.punchline = this.data.punchline;
    this.confirmButtonText = this.data.confirmButtonText || this.confirmButtonText;
  }

}
